import { useLocalizedString } from '@volvo-cars/react-locale-provider';
import { label as labelTranslations } from '../../i18n/prev/i18n';
import { IconButton, type LocalizedIconButtonProps } from '../icon-button';

/**
 * A button for navigating to the previous item, page, or step.
 * Uses the useLocale hook from LocaleProvider context to provide an accessible label
 * based on the current locale, or wraps with one if `locale` is provided.
 */
export function PrevIconButton(props: LocalizedIconButtonProps) {
  const label = useLocalizedString(labelTranslations);
  return <IconButton icon="chevron-back" aria-label={label} {...props} />;
}
